import { numberToThousandsString } from 'core/Utils';
import { Flex, Text } from 'ui';
import { IconProfile } from 'ui/Icons';

export const CampaignParticipants = ({ number }: { number?: number }) => {
  if (!number) return null;
  const formattedNumber = numberToThousandsString(number);

  return (
    <Flex gap="xs" align={'center'}>
      <IconProfile size="16px" color="#AAAAAA" />
      <Text size="xs">{formattedNumber || 0}</Text>
    </Flex>
  );
};
